"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionPage = QuestionPage;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@kalkulacka-one/design-system/client");
const server_1 = require("@kalkulacka-one/design-system/server");
const js_1 = require("@mdi/js");
const next_intl_1 = require("next-intl");
const client_2 = require("../../client/index.js");
const embed_footer_1 = require("../embed-footer.js");
const embed_layout_1 = require("../embed-layout.js");
const fixed_layout_1 = require("../fixed-layout.js");
const question_card_1 = require("../question-card.js");
const question_navigation_card_1 = require("../question-navigation-card.js");
function QuestionPage({ embedContext, homepageHref, privacyHref, question, number, total, calculator, onPreviousClick, onNextClick, answer, onCloseClick }) {
    const t = (0, next_intl_1.useTranslations)("koa.pages");
    const isAnswered = answer.answer?.answer !== undefined;
    const handleAgreeChange = (checked) => {
        if (checked) {
            answer.setAnswer({
                questionId: question.id,
                answer: true,
            });
            onNextClick();
        }
        else {
            answer.setAnswer({
                questionId: question.id,
                answer: undefined,
            });
        }
    };
    const handleDisagreeChange = (checked) => {
        if (checked) {
            answer.setAnswer({
                questionId: question.id,
                answer: false,
            });
            onNextClick();
        }
        else {
            answer.setAnswer({
                questionId: question.id,
                answer: undefined,
            });
        }
    };
    const handleImportantChange = (checked) => {
        answer.setAnswer({
            questionId: question.id,
            isImportant: checked,
        });
    };
    const PageLayout = embedContext.isEmbed ? embed_layout_1.EmbedLayout : fixed_layout_1.FixedLayout;
    return ((0, jsx_runtime_1.jsxs)(PageLayout, { children: [(0, jsx_runtime_1.jsx)(PageLayout.Header, { children: (0, jsx_runtime_1.jsx)(client_2.AppHeader, { calculator: calculator, children: (0, jsx_runtime_1.jsx)(client_2.AppHeader.Right, { children: (0, jsx_runtime_1.jsx)(client_2.Closable, { children: (0, jsx_runtime_1.jsx)(client_1.Button, { variant: "round", color: "neutral", size: "small", "aria-label": t("common.closeCalculator"), title: t("common.closeCalculator"), onClick: onCloseClick, children: (0, jsx_runtime_1.jsx)(client_1.Icon, { icon: js_1.mdiClose, size: "medium", decorative: true }) }) }) }) }) }), (0, jsx_runtime_1.jsx)(PageLayout.Content, { fullWidth: true, fullHeight: true, children: (0, jsx_runtime_1.jsxs)("div", { className: "koa:mx-auto koa:flex koa:w-full koa:min-w-0 koa:max-w-[51.25rem] koa:min-h-0 koa:flex-1 koa:flex-col koa:gap-4 koa:sm:gap-6", children: [(0, jsx_runtime_1.jsx)(server_1.SteppedProgressBar, { stepItems: Array.from({ length: total }, (_, index) => ({ id: String(index + 1), status: null })), stepCurrent: number, stepTotal: total, idKey: "id", statusKey: "status", decorative: true }), (0, jsx_runtime_1.jsx)(question_card_1.QuestionCard, { question: question, answer: answer, onAgreeChange: handleAgreeChange, onDisagreeChange: handleDisagreeChange, onImportantChange: handleImportantChange }), (0, jsx_runtime_1.jsx)(question_navigation_card_1.QuestionNavigationCard, { current: number, total: total, isAnswered: isAnswered, onPreviousClick: onPreviousClick, onNextClick: onNextClick })] }) }), (0, jsx_runtime_1.jsx)(PageLayout.Footer, { children: embedContext.isEmbed && (0, jsx_runtime_1.jsx)(embed_footer_1.EmbedFooter, { attribution: embedContext.config?.attribution, homepageHref: homepageHref, privacyHref: privacyHref }) })] }));
}
